import { RefObject, useEffect } from "react";

import { isDefined } from "@utils/helpers";

import { PreferredStoreService } from "@services/preferredStore.service";

import {
    Translate,
    useGranite,
} from "@redux/modules/value/translations/translations.provider";

import { useLanguage } from "@context/language.context";

import { TooltipTemplate } from "../components/map/tooltip.template";
import { findStoreById } from "../queries/findStoreById.query";
import { MARKER_OFFSET, markerFavUrl } from "../storeSearch.config";
import { findStoreUrl } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";
import { useMap } from "./useMap.hook";
import { useWoosmapServices } from "./useWoosmapServices.hook";

const renderMarker =
    (storeUrls: StoreUrl[], map: woosmap.map.Map, t: Translate) =>
    (favoriteStore?: woosmap.map.stores.StoreResponse) => {
        if (!isDefined(favoriteStore)) return;

        const marker = new woosmap.map.Marker({
            position: {
                lat: favoriteStore.geometry.coordinates[1],
                lng: favoriteStore.geometry.coordinates[0],
            },
            icon: markerFavUrl,
        });
        marker.setMap(map);
        const infoWindow = new woosmap.map.InfoWindow({});

        infoWindow.setOffset(new woosmap.map.Point(0, MARKER_OFFSET));
        infoWindow.setContent(
            TooltipTemplate(
                t,
                favoriteStore.properties,
                findStoreUrl(
                    storeUrls,
                    favoriteStore.properties.user_properties.storeId,
                ),
            ),
        );
        marker.addListener("click", () => {
            if (map) {
                infoWindow.open(map, marker.getPosition());
            }
        });
    };

export const useFavoriteStore = async (
    mapElementRef: RefObject<HTMLDivElement>,
    storeUrls: StoreUrl[],
) => {
    const { StoresService } = useWoosmapServices();
    const { getLocale } = useLanguage();

    const map = useMap(mapElementRef);

    const { t } = useGranite();

    useEffect(() => {
        const favoriteStoreId =
            PreferredStoreService.getPreferredStoreOfTheUser();

        if (!isDefined(map) || !isDefined(favoriteStoreId)) return;

        findStoreById(StoresService, favoriteStoreId, getLocale()).then(
            renderMarker(storeUrls, map, t),
        );
    }, [map]);
};
